// Coaches mirror the actual Exonome offering listings.
// Names match what's printed on each offering's promo image so nothing contradicts.
export const COACHES = [
  {
    id: "lawson-luo",
    name: "Lawson Luo",
    role: "Senior Coach · Teen Lessons",
    intro:
      "USGTF & TPI certified with 20+ years coaching in China and the US. Studied under Maki Oto and Tiger Woods' coaches Butch Harmon and Hank Haney.",
    specialties: ["Novice", "Intermediate", "Teen", "20+ yrs"],
    priceFrom: 60,
    image:
      "https://tricklyioazurestorage.blob.core.windows.net/offerings/5998/of_hero.png",
    href: "https://connect.exono.me/IM/7780",
  },
  {
    id: "tyler-brooks",
    name: "Tyler Brooks",
    role: "Performance Coach · Premium Private",
    intro:
      "A comfortable, premium environment built for new golfers. Lessons tailored to your pace and goals, with flexible scheduling and on-course practice.",
    specialties: ["Private", "Premium", "Swing", "Confidence"],
    priceFrom: 70,
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_swing-connect-11/artifacts/fm4djf2u_d52e67fd-09d9-43a6-a39c-7a8ff2346a13.png",
    href: "https://connect.exono.me/IM/7863",
  },
  {
    id: "sarah-johnson",
    name: "Sarah Johnson",
    role: "Junior Golf Coach",
    intro:
      "Fun, engaging lessons for kids ages 5–16. Focus on fundamentals, coordination and confidence — games, drills and a supportive environment.",
    specialties: ["Kids 5–16", "Junior", "Coordination", "Fun Learning"],
    priceFrom: 55,
    image:
      "https://tricklyioazurestorage.blob.core.windows.net/offerings/6040/of_hero.png",
    href: "https://connect.exono.me/IM/7856",
  },
  {
    id: "michael-carter",
    name: "Michael Carter",
    role: "Short Game & Putting Specialist",
    intro:
      "Elite short game training — putting consistency, chipping control, bunker play and course management. Lower scores, gain confidence around the green.",
    specialties: ["Putting", "Chipping", "Bunker Play", "Scoring"],
    priceFrom: 50,
    image:
      "https://tricklyioazurestorage.blob.core.windows.net/offerings/6045/of_hero.png",
    href: "https://connect.exono.me/IM/7865",
  },
  {
    id: "morgan-wright",
    name: "Morgan Wright",
    role: "Performance Coach · PGA Certified",
    intro:
      "Private coaching for adults and teenagers — swing fundamentals, short game, putting, course strategy and confidence. From first swing to on-course play.",
    specialties: ["PGA Certified", "Adult", "Teen", "Course Strategy"],
    priceFrom: 60,
    image:
      "https://tricklyioazurestorage.blob.core.windows.net/offerings/6000/of_hero.png",
    href: "https://connect.exono.me/IM/7783",
  },
];
